(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-sort-dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Get all sort dropdown containers with class 'dropdown-content' containing sort links
  document.querySelectorAll('.dropdown-content').forEach(container => {
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');
    const baseUrl = container.getAttribute('data-base-url') || '';

    // Remove font-bold from all links in this container first
    container.querySelectorAll('a').forEach(link => {
      link.classList.remove('font-bold');
    });

    container.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href');
      if ((!sortBy && href === baseUrl) || (sortBy === 'newest' && href === baseUrl)) {
        link.classList.add('font-bold');
      } else if (sortBy === 'oldest' && href.includes('sort_by=oldest')) {
        link.classList.add('font-bold');
      }
    });
  });

  // Update aria-expanded on details toggle for accessibility
  document.querySelectorAll('details').forEach(detailsElem => {
    const summary = detailsElem.querySelector('summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', detailsElem.hasAttribute('open'));

    detailsElem.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', detailsElem.hasAttribute('open'));
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
